import { Component, effect, inject, linkedSignal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NoOpLink } from "@kno2/common/directives";
import { LocalStorageService } from "@kno2/core/storage";
import { InfoPopoverComponent } from "@kno2/shared/info-popover";
import { SignaturesDraftsComponent } from "./signatures-drafts.component";
import { SignaturesHistoryComponent } from "./signatures-history.component";

const SIGNATURE_ACTIVE_TAB_KEY = "getSignatures.activeTab";

@Component({
    selector: "kno2-signatures",
    imports: [NoOpLink, RouterLink, InfoPopoverComponent, SignaturesHistoryComponent, SignaturesDraftsComponent],
    templateUrl: "./signatures.component.html"
})
export class SignaturesComponent {
    private readonly localStorageService = inject(LocalStorageService);

    protected activeTab = linkedSignal(() => this.localStorageService.get(SIGNATURE_ACTIVE_TAB_KEY) || "events");
    protected setActiveTabEffect = effect(() => this.localStorageService.set(SIGNATURE_ACTIVE_TAB_KEY, this.activeTab()));
}
